import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState({ products: 0, active: 0, sold: 0, orders: 0 });
  useEffect(() => {
    Promise.all([api.get("/admin/products"), api.get("/admin/orders")]).then(([pR, oR]) => {
      const prods = pR.data;
      setStats({
        products: prods.length,
        active: prods.filter((p) => p.product_status === "active").length,
        sold: prods.filter((p) => p.product_status === "sold_out").length,
        orders: oR.data.length,
      });
    });
  }, []);
  const cards = [
    ["Total Products", stats.products], ["In the Cabinet", stats.active],
    ["Found a New Home", stats.sold], ["Total Orders", stats.orders],
  ];
  return (
    <div>
      <h1 className="font-display text-3xl text-gold mb-8">Welcome back, proprietor</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(([l, v]) => (
          <div key={l} className="curio-card p-6">
            <div className="font-caption text-[10px] text-brass mb-2">{l}</div>
            <div className="font-display text-4xl text-gold">{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
